import Link from 'next/link';
import React from 'react';
import { useDarkMode } from '../utils/hooks/useDarkMode';

export default function Custom404() {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`min-vh-100 d-flex align-items-center justify-content-center ${isDarkMode ? 'bg-dark text-white' : 'bg-light'}`}>
            <div className="text-center">
                <h1 className="display-1 fw-bold text-primary">404</h1>
                <h2 className="h4 mb-4">Page Not Found</h2>
                <p className="mb-4">The page you&apos;re looking for doesn&apos;t exist.</p>
                <Link href="/" className="btn btn-primary">
                    Go Home
                </Link>
            </div>
        </div>
    );
}
